export const sandboxT = {
  common: {
    labels: {
      currencyOption: 'Currency',
      fundingReference: 'Funding reference',
      beneficiaryAccount: 'Beneficiary Account',
      amount: 'Amount',
      sandbox: 'Sandbox'
    },
    actions: {
      addFunds: 'Add funds',
      execute: 'Execute'
    },
    placeholders: {
      amount: '0.0',
      selectTestCase: 'Select test case'
    },
    notifications: {
      testCaseExecuted: 'Test case executed',
      serverError: 'Server error occurred'
    },
    tooltips: {
      fundingInstructions: 'From Details > Funding instructions'
    },
    documentation: {
      label: 'documentation',
      see: 'See',
      forMoreDetails: 'for more details.'
    }
  },
  addFunds: {
    title: 'Add funds',
    alert:
      'In the Sandbox environment, you can simulate a funding request based on the funding instructions configured for the current account.',
    notifications: {
      successTitle: 'Funds added',
      successBody: 'Your sandbox funding test case was triggered successfully.',
      errorTitle: 'Failed to add funds',
      errorBody:
        'Something went wrong triggering the sandbox funding test case.'
    }
  },
  topBanner: {
    nonProduction:
      "You're in a non-production environment. Any changes made here won't impact your live data."
  },
  orderTestCases: {
    alert:
      'In Sandbox environment, you can execute collection order test cases.'
  },
  payoutTestCases: {
    labels: {
      success: 'Complete',
      returned: 'Returned'
    },
    alert: {
      withTestCases:
        'In Sandbox environment you can execute payout request test cases.',
      restricted:
        "In Sandbox environment you can execute test cases for payouts that are 'Completed' or 'Processing'."
    }
  }
} as const;
